<script>
import { h } from 'vue'
export default {
  name: 'KeywordText',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    }
  },
  render(ctx) {
    const vnodes = []
    const text = this.text.split(this.keyword)
    const style = [
      'color: #000',
      'background: #D8EAFF',
    ].join(';')
    text.forEach(str => {
      vnodes.push(h('span', null, str))
      vnodes.push(h('span', { style: style }, this.keyword))
    })
    if (text.length > 0) {
      vnodes.pop()
    }
    return h('span', null, vnodes)
  }
}
</script>
